module.exports = __webpack_public_path__ + "796f9e34ec8d911a4dff0595e20bcee7.pdf";